/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Wild_Snail_SingInputs */

const en_quiet_wild_snail_sing = /** @type {(inputs: Quiet_Wild_Snail_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`name@email.de`)
};

const de_quiet_wild_snail_sing = /** @type {(inputs: Quiet_Wild_Snail_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`name@email.de`)
};

/**
* | output |
* | --- |
* | "name@email.de" |
*
* @param {Quiet_Wild_Snail_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_wild_snail_sing = /** @type {((inputs?: Quiet_Wild_Snail_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Wild_Snail_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_wild_snail_sing(inputs)
	return de_quiet_wild_snail_sing(inputs)
});